import React from 'react';
//import PropTypes from 'prop-types';
import { Outlet } from 'react-router';

function SimulationJobsRoot(props) {
    return <Outlet />;
}

SimulationJobsRoot.propTypes = {};

export default SimulationJobsRoot;
